export const APP_NAME = 'Medium'

export const ARTICLES_LIMIT = 10
